import { Component, HostListener, OnInit } from '@angular/core';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { NgFor, NgIf } from '@angular/common';
import { UserStaffService } from '../../../../Services/User/Staff/user-staff.service';

@Component({
  selector: 'app-admin-staff-list',
  standalone: true,
  imports: [NgFor, NgIf, RouterModule],
  templateUrl: './admin-staff-list.component.html',
  styleUrls: ['./admin-staff-list.component.css'] // fix typo: styleUrls
})
export class AdminStaffListComponent implements OnInit {
  staffList: any[] = [];
  openMenuForStaffId: number | null = null;

  constructor(
    private userStaffService: UserStaffService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.loadStaffList();
  }

  private loadStaffList() {
    this.userStaffService.getUserStaff().subscribe({
      next: (res: any) => {
        this.staffList = res?.data || [];
        console.log('Loaded staffList', this.staffList);
      },
      error: err => {
        console.error('Failed to load staff list', err);
      }
    });
  }

  // toggle inline action menu for a row
  onRowClick(staff: any, event: MouseEvent) {
    event.stopPropagation();
    const id = staff?.id;
    if (id === undefined || id === null) {
      console.error('staff.id missing', staff);
      return;
    }
    this.openMenuForStaffId = this.openMenuForStaffId === id ? null : id;
    console.log('Toggled menu for', id);
  }

  // Navigate to AdminTagginglist (Issue)
  // Navigate to AdminTagginglist (Issue)
onIssue(staff: any) {
  const id = staff?.id;
  const name = staff?.name ? encodeURIComponent(staff.name) : '';
  if (id === undefined || id === null) {
    console.error('Missing id for Issue', staff);
    return;
  }
  this.openMenuForStaffId = null;
  // Absolute path to the admintagginglist child of admin-panel
  const route = ['/admin-panel/admintagginglist', id, name];
  console.log('Navigate Issue ->', route.join('/'));
  this.router.navigate(route).catch(err => console.error('Navigation error', err));
}

  // Navigate to AdminKalakar (Assign)
  onAssign(staff: any) {
    const id = staff?.id;
    const name = staff?.name ? encodeURIComponent(staff.name) : '';
    if (id === undefined || id === null) {
      console.error('Missing id for Assign', staff);
      return;
    }
    this.openMenuForStaffId = null;
    const route = ['/admin-panel/adminkalakar', id, name];
    console.log('Navigate Assign ->', route.join('/'));
    this.router.navigate(route).catch(err => console.error('Navigation error', err));
  }

  // close any open inline menu when clicking outside
  @HostListener('document:click')
  onDocumentClick() {
    this.openMenuForStaffId = null;
  }
}
